//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'home',
        data() {
            return {
                wxLink: false
            }
        },
        
        methods: {
            linkFunClick() {
                this.$router.go(-1)
            }
        }
    }
